export const text = {
  Academy: "Academy",
  CategoryName: "Category Name",
  ChapterNo: "Chapter No",
  Lesson: "Lesson",
  CourseName: "Course Name",
  Category: "Category",
  LessonNo: "Lesson No",
  Course: "Course",
  AddCategory: "Add Category",
  AddCourse: "Add Course",
  AddLesson: "Add Lesson",
  AddChapter: "Add Chapter",
  Courses: "Courses",
  Lesson: "Lesson",
  Chapter: "Chapter",
  SelectMediaType: "Select Media Type",
  Video: "Video",
  Image: "Image",
  Categoryaddedsuccessfully: "Category added successfully!",
  Anattachmentisrequired: "An attachment is required",
  Categoryupdatedsuccessfully: "Category updated successfully!",
  CategoryDeletedsuccessfully: "Category Deleted successfully!",
  Chapteraddedsuccessfully: "Chapter added successfully!",
  PleaseaddQuestiontoyourChapter: "Please add Question to your Chapter.",
  Chapterupdatedsuccessfully: "Chapter updated successfully!",
  ChapterDeletedsuccessfully: "Chapter Deleted successfully!",
  Courseaddedsuccessfully: "Course added successfully!",
  Courseupdatedsuccessfully: "Course updated successfully!",
  CourseDeletedsuccessfully: "Course Deleted successfully!",
  AssignCourseToTeam: "Assign Course To Team",
  AssignCourseToTeamupdatedsuccessfully:
    "Assign Course To Team updated successfully!",
  AssignCourseToTeamAddedsuccessfully:
    "Assign Course To Team Added successfully!",
  Assignto: "Assign to",
  Lessonaddedsuccessfully: "Lesson added successfully!",
  Lessonupdatedsuccessfully: "Lesson updated successfully!",
  LessonDeletedsuccessfully: "Lesson Deleted successfully!",
};
